export default __webpack_public_path__ + "static/media/logo-rectangle.2e8d2607.png";